import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Empty } from "antd"

//------------------------------------------------------------------------------

function EmptyData(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { description } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  return <Empty className={props.className} description={description} />
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

EmptyData.propTypes = {
  className: PropTypes.string.isRequired,
  description: PropTypes.string,
}

EmptyData.defaultProps = {
  description: "No data.",
}

// ----------------------------------------------------------------------------

const StyledEmptyData = styled(EmptyData)`
  & {
    .ant-empty-description {
      font-size: 14px;
      color: ${(props) => props.theme.colors.textSecondaryColor};
    }
  }
`
// ----------------------------------------------------------------------------

export default StyledEmptyData
